import { useCallback, useEffect, useState } from 'react';

export interface AudioPermission {
  canPlayAudio: boolean;
  checked: boolean;
  checkAudioPermisson: () => void;
}

export const useAudioPermission = () => {
  const [canPlayAudio, setCanPlayAudio] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);

  const checkAudioPermission = useCallback(() => {
    const canPlay = navigator.userActivation.hasBeenActive;
    setCanPlayAudio(canPlay);
    setChecked(true);
    return canPlay;
  }, []);

  // Initialize audio support check on mount
  useEffect(() => {
    checkAudioPermission();
  }, [checkAudioPermission]);

  return {
    canPlayAudio,
    checked,
    checkAudioPermission,
  };
};
